import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
};

export const noData: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const scrollbar: SxStyle = {
  height: (p) => p.spacing(44),
};
